import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import {
  COMPANY_ID,
  EMPLOYEE_ID,
  EVENT_ID,
  SITE_TOKEN,
  SITE_ID,
} from '@config/global-constants';
import { TokenSessionService } from '@app/shared/services';
import { I18n } from '@app/i18n/strings-keys';
import { I18nService } from '@app/shared/services/i18n/i18n.service';

@Injectable()
export class AuthGuard {
  public constructor(
    private tokenSessionService: TokenSessionService,
    private router: Router,
    private i18nService: I18nService,
  ) {}

  public canActivate(): boolean {
    if (
      !this.tokenSessionService.getToken(COMPANY_ID) ||
      !this.tokenSessionService.getToken(SITE_TOKEN) ||
      !this.tokenSessionService.getToken(SITE_ID)
    ) {
      this.tokenSessionService.removeToken(SITE_ID);
      this.tokenSessionService.removeToken(SITE_TOKEN);
      this.tokenSessionService.removeToken(COMPANY_ID);
      this.tokenSessionService.removeToken(EMPLOYEE_ID);
      this.tokenSessionService.removeToken(EVENT_ID);

      this.router.navigateByUrl('error', {
        state: {
          message: this.i18nService.instant(I18n.ErrorStrings.IncorrectUrl),
        },
      });
      return false;
    }
    return true;
  }
}
